import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import FocusTrap from 'focus-trap-react';
import { Typography, ModalPortal } from '@alltrails/core';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import Dandelion from '@alltrails/denali/illustrations/Dandelion';
import styles from './FeebackModal.module.scss';

type Props = {
  isOpen: boolean;
  closeModal: () => void;
};

const FeedbackModal = ({ isOpen, closeModal }: Props) => {
  const isMobile = useIsMobileSizedScreen();
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => closeModal(), 2000);
    }
  }, [isOpen]);

  const variant = isMobile ? 'heading300' : 'heading400';
  return isOpen ? (
    <ModalPortal>
      <div className={styles.modal} id="feedback-container">
        <FocusTrap
          active={isOpen}
          // fallbackFocus is used to prevent errors in testing https://github.com/focus-trap/focus-trap-react/issues/91
          focusTrapOptions={{
            fallbackFocus: '#feedback-container'
          }}
        >
          <div className={styles.content}>
            <div className={styles.icon}>
              <Dandelion size="lg" />
            </div>
            <Typography variant={variant}>
              <FormattedMessage defaultMessage="Thanks for sharing" />
            </Typography>
            <div className={styles.secondaryText}>
              <Typography variant="text200" color="secondary">
                <FormattedMessage defaultMessage="Your feedback makes AllTrails better" />
              </Typography>
            </div>
          </div>
        </FocusTrap>
      </div>
    </ModalPortal>
  ) : null;
};

export default FeedbackModal;
